import {
  GLOBAL_SEARCH_RESULT_TYPE_ORDER,
  type GlobalSearchResultTypeEnum,
} from '../../../../value-objects/enums'
import {
  GlobalSearchTabTypes,
  type GlobalSearchTab,
} from '../../enums/GlobalSearchTabTypeEnum'

interface IDeriveTabsInput {
  counts: Map<GlobalSearchResultTypeEnum, number>
  total: number
}

export function deriveTabs(
  input: Nullable<IDeriveTabsInput>
): Nullable<GlobalSearchTab[]> {
  if (!input) {
    return null
  }

  const resultTypeTabs: GlobalSearchTab[] = []
  for (const type of GLOBAL_SEARCH_RESULT_TYPE_ORDER) {
    const count = input.counts.get(type)
    if (count && count > 0) {
      resultTypeTabs.push({ type, count })
    }
  }

  if (resultTypeTabs.length <= 1) {
    return null
  }

  return [
    { type: GlobalSearchTabTypes.ALL, count: input.total },
    ...resultTypeTabs,
  ]
}
